export const COOKIES_AGREE_KEY = 'user_agree';
